module.exports = __webpack_public_path__ + "static/media/Profile_6.cbf4d45f.svg";